import { Headset } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import Spacing from '../Spacing';
import { getInitials, getPractice, notify } from '../../helpers';
import { fetchAllSupports } from '../../services/Support';
import SupportAdminSingleMessage from '../Section/SupportAdminSingleMessage';
import { useNavigate } from 'react-router-dom';

export default function SupportMessages({selectedPracticeChange,fetchChangePracticeData}) {
    var location_id = getPractice("location_id");
    var account_id = getPractice("account_id");
    if(selectedPracticeChange != null && fetchChangePracticeData){
      location_id = selectedPracticeChange?.location_id;
      account_id = selectedPracticeChange?.account_id;
    }
    
    const [dataLoading, setDataLoading] = useState(true);
    const [supportList, setSupportList] = useState([]);
    const navigate = useNavigate();
    const [selecteditemId, setSelecteditemId] = useState(null);


    const loadAllSupports = async () => {
      let isCanceled = false;

      try {
        const response = await fetchAllSupports();
        setSupportList(response?.data?.results);
      } catch (error) {
        if (error?.code === "ERR_CANCELED" || error?.name === "CanceledError") {
          isCanceled = true;
        } else {
          notify("error", 'Something went wrong to fatching support data');
        }
      } finally {
        if (!isCanceled) {
          setDataLoading(false);
        }
      }
    };
  
    useEffect(() => {
      loadAllSupports();
    }, []);

  
    return (
      <>
        <div className="docpro_page_heading_wrap">
          <h2 className="docpro_page_heading docpro_fs_24 docpro_mb_0">
            <i
              className="docpro_white_color"
              style={{ backgroundColor: '#53B9AB' }}
            >
              <Headset width={20} height={20} />
            </i>
            Support Messages
          </h2>
        </div>
        <Spacing lg="20" sm="20" />
        <div className="docpro_messanger_wrap">
          <div className={`docpro_messanger_sidebar`}>
            <p className="docpro_fs_16 docpro_fw_500 docpro_primary_color text-center" style={{ marginBottom: '15px' }} >
              Support Ticket Practice List
            </p>
            <div style={{ width: "100%", flexGrow: 1, height: "1px", backgroundColor: "var(--vivid)", marginTop: "10px", marginBottom:"10px" }}/>
            <div className="docpro_users">
              {!dataLoading ? (
                supportList.length > 0 ? (
                  supportList?.slice()
                  .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((item, index) => (
                    <div onClick={() => {
                      setSelecteditemId(item.case_id);
                      navigate(`/support-messages/${item.case_id}`, {
                        state: {
                          selectedSupport: item,
                        },
                      });
                      }
                      } className="docpro_user" key={index}
                      style={{
                        backgroundColor: selecteditemId === item.case_id ? "#e1f0ff" : "transparent",
                        cursor: "pointer",
                      }}
                      >
                      <div className="docpro_message_item_avatar  shoutbox_img_avatar">
                          {getInitials(`${item.location_name}`)}{" "}
                        <span className="docpro_tip">{item?.location_name}</span>
                      </div>
                      <div className="docpro_user_info">
                        <h3 className="docpro_fs_14 docpro_primary_color">{item?.practice_name}</h3>
                        <p className="docpro_primary_color">{item?.location_name}</p>
                        <p className="docpro_primary_color">{item?.subject}</p>
                      </div>
                      <div className="docpro_message_date docpro_fs_12">{item.case_id}</div>
                      <div className="docpro_message_date docpro_fs_12"  style={{textAlign:'right',marginLeft:"1rem",marginTop:"1.5rem"}}>{ item?.status ?  <span className="docpro_badge docpro_badge_green">
                        Open
                      </span> :  <span className="docpro_badge docpro_badge_red">
                        Closed
                      </span>}</div>
                    </div>
                  ))
                ) : (
                  <p className="no_data text-center" colSpan="7">
                  No ticket available
                  </p>
                )
              ) : (
                <p className="no_data text-center" colSpan="7">
                  Loading....
                  </p>
              )}
              
            </div>
          </div>
          <SupportAdminSingleMessage />
        </div>
      </>
    );
}
  